import { render, staticRenderFns } from "./FormAudience.vue?vue&type=template&id=20c65a63&lang=pug"
import script from "./FormAudience.vue?vue&type=script&lang=js"
export * from "./FormAudience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports